var _defs, _image;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAriaCondizionata(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect9",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#09253e",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 12.228516,9 C 10.717204,9 9.5,10.217204 9.5,11.728516 V 22.271484 C 9.5,23.782796 10.717204,25 12.228516,25 H 37.771484 C 39.282796,25 40.5,23.782796 40.5,22.271484 V 11.728516 C 40.5,10.217204 39.282796,9 37.771484,9 Z M 22,13.25 h 6 v 1.3 h -6 z m -7.25,4.129844 h 20.5 c 0.552285,0 1,0.447715 1,1 v 1.320312 h -22.5 v -1.320312 c 0,-0.552285 0.447715,-1 1,-1 z m -1,3.819883 h 22.5 v 2.300781 l -22.5,0.0098 z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#09253e",
    strokeMiterlimit: 10,
    strokeDasharray: "2.65 2.65",
    x1: 25,
    y1: 27.199913,
    x2: 25,
    y2: 44.412933,
    id: "line4",
    style: {
      strokeWidth: 1,
      strokeDasharray: "2.65000706,2.65000706",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#09253e",
    strokeMiterlimit: 10,
    strokeDasharray: 2.5,
    d: "M18.38,27.38c-.05,2.26.3,12.21-6.76,16.24",
    id: "path5",
    style: {
      strokeWidth: 1,
      strokeDasharray: 2.50000009,
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#09253e",
    strokeMiterlimit: 10,
    strokeDasharray: 2.5,
    d: "M31.62,27.38c.05,2.26-.3,12.21,6.76,16.24",
    id: "path6",
    style: {
      strokeWidth: 1,
      strokeDasharray: 2.50000009,
      strokeDashoffset: 0
    }
  }), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 330.3212,
    height: 84.34269,
    preserveAspectRatio: "none",
    id: "image1",
    x: -103.25256,
    y: -144.74841
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAriaCondizionata);
export default __webpack_public_path__ + "static/media/aria_condizionata.744ecddeaa2424369b2a0d37c80de8d2.svg";
export { ForwardRef as ReactComponent };